export default "__VITE_ASSET__DOX9GKF3__"